/**
 * Return a string of the current page's query params
 *
 * @returns {string} Returns - A string of the current page's query params
 */
export function getQueryParams() {
    return window.location.search.substring(1);
}

/**
 * Return an array of query param objects
 *
 * @returns {Array} Returns - An array of all the query param objects
 */
export function splitQueryParams() {
    const queryParams = getQueryParams();
    return queryParams.split('&');
}

/**
 * Gets the query string variable - the name is not case sensitive
 * See http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 */
export function getParameterByName(name, url) {
    let workUrl = url;
    let workName = name;

    if (!workUrl) {
        workUrl = window.location.href;
    }
    workName = workName.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${workName}(=([^&#]*)|&|#|$)`, 'i');
    const results = regex.exec(workUrl);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getNonRelatedQueryStrings(queryString, listingAppID) {
    if (!listingAppID || !queryString) { return []; }

    // Map the variables to an object
    const nonRelatedQueryStrings = [];
    const variables = queryString.split('&');
    variables.forEach(variable => {
        const arr = variable.split('=');
        const key = arr[0];

        // If the key start with the listing identifier, skip this entry
        if (key.indexOf(listingAppID) === 0) { return; }

        // Add the non related query strings
        nonRelatedQueryStrings.push(variable);
    });

    return nonRelatedQueryStrings;
}
